<div class="list-page">
  <div class="list-page__add-block">
    <button-cmp class="add-button-block" (click)="onAddButtonClick()" isLogin="false" isAdd="true"
      title="Add Book"></button-cmp>
  </div>
  <div class="list-page__table-block">
    <app-books-table *ngIf="booksList$ | async as list" [table-data]="list.slice().reverse()"
      [page]="page" class="table-block" (action)="receivedAction($event)"></app-books-table>
    <!-- <table-cmp *ngIf="booksList$ | async as list" [isSlokaType]="true" [table-data]="list.slice().reverse()"
      [page]="page" class="table-block" (action)="receivedAction($event)"></table-cmp> -->
  </div>
  <div class="list-page__pagination-block">
    <pagination-controls class="table-paginate" (pageChange)="page = $event"></pagination-controls>
  </div>
</div>